export class SkechersItemNoDtoReq {
  id: string;
  itemNo?: string;
  poNumber?: string
  poStyle?: string
  exFactoryDate?: string
  price?: string
  constructor(
    id: string,
    itemNo?: string,
    poNumber?: string,
    poStyle?: string,
    exFactoryDate?: string,
    price?: string,
  ) {
    this.id = id,
    this.itemNo = itemNo;
    this.poNumber = poNumber;
    this.poStyle = poStyle;
    this.exFactoryDate = exFactoryDate
    this.price = price
  }
}